import React, { useMemo } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import useQueryString from 'utils/hooks/useQueryString';

export const ErrorPaste = ()=>{
    const navigate = useNavigate();
    const { school } = useParams();
    const { type } = useQueryString();
    

    const typeName = useMemo(() => {
        switch (type) {
            case 'bookreport':
                return "독서감상문";
            case "userbook":
                return "나도작가다";
            case "dongwha":
                return "동화서당";
            default:
                break;
        }
    }, [type])

    return(
        <div className="section">
            <div className="inner bbs">
                <div className="alert_box alignC">
                    <h1 className="title"><span>붙여넣기</span>를 사용 할 수 없습니다.</h1>
                    <p>
                        {typeName}에서 정상적이지 않은 동작이 확인되었습니다.<br />
                        복사해서 붙여넣기 및 여타 부정행위를 방지합니다.
                    </p>
                    <div className="bbs_btn">
                        <Link to={`/${school}/`} className="btn _sm _blue">홈</Link>
                        &nbsp;
                        <button className="btn _sm gray20" onClick={()=>navigate(-1)}>이전 페이지</button>
                        &nbsp;
                    </div>
                </div>
            </div>
        </div>
    );
};